// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bff_a"};